// extracted by mini-css-extract-plugin
export default {"Day":"styles_Day__M3502"};